import { Range } from '@weareopenr/types';
import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export enum EProductLibraryStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  PENDING = 'PENDING',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
}

export interface ISyncProduct {
  id: string;
  name: string;
  ranges: Range[];
}

export interface IStatus {
  endpoint_name: string;
  external_system_name: string;
  sync_status: EProductLibraryStatus;
  sync_id: string;
  /**
   * Legacy sync diff, computed server-side. Only the pre-ingest pipeline populates it — syncs
   * routed through service-ingest expose their diff via `GET /ingest/diff/{eventId}` instead.
   */
  diff?: {
    inserts: ISyncProduct[];
    updates: ISyncProduct[];
    deletes: ISyncProduct[];
  };
}

export const getProductLibrarySyncStatus = async (): Promise<IStatus | null> => {
  try {
    const res = await fetch(`${API_URL}/items/sync/status`);

    if (!res.ok) throw new Error('Response not OK when fetching product library sync status');
    if (res.status === Status.SUCCESS) {
      return await res.json();
    }
    return null;
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Could not get sync status';
    throw new Error(`Could not get sync status: ${message}`);
  }
};
